import { Group } from "three";
import { Utils } from "../../Utils/Utils.js";
import { Cone } from "../Primitive/Cone.js";
export class DraggableCone2 extends Group {
    constructor(color, radius, height) {
        super();
        this.add(this.A = new Cone(color, radius, height / 2).translateY(height / 4), this.B = new Cone(color, radius, height / 2).translateY(height / -4).rotateZ(Math.PI));
        this.objectsToRaycast = [this.A, this.B];
        this.isDraggable = true;
        this.bindEvent("onHover", () => {
            const scene = Utils.getScene(this);
            scene?.outlinePass && (scene.outlinePass.selectedObjects = [this]);
            this.needsRender = true;
        });
        this.bindEvent("onLeave", () => {
            const scene = Utils.getScene(this);
            scene?.outlinePass && (scene.outlinePass.selectedObjects = []);
            this.needsRender = true;
        });
    }
}
//# sourceMappingURL=DraggableCone2.js.map